export const SHARE_ZIP_VERSION = 6
export const FAVOURITES_VERSION = '1.0'
export const OLD_FAVOURITES_VERSION = '1.0'
export const APP_VERSION_REQUEST = 3
